import { applySettingsToAll, setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useMoreOptionsContent = (textBox: TextBox) => {
    const dispatch = useAppDispatch();

    function handleAllCapsClick() {
        dispatch(
            setSettings({
                id: textBox.id,
                forceCaps: !textBox.forceCaps,
            }),
        );
    }

    function handleApplyToAllFonts() {
        dispatch(applySettingsToAll(textBox.id));
    }

    return {
        handleAllCapsClick,
        handleApplyToAllFonts,
    };
};
